<div class="modal-body" id="errorModal">
    <p>Alcuni valori inseriti sono errati, mancanti o incompleti. Controlla i campi evidenziati in rosso.</p>
    <div class="modal-footer">
        <button (click)="dismiss()" type="button" class="btn btn-secondary modal-close-btn" data-dismiss="modal">Chiudi</button>
    </div>
</div>